export default __webpack_public_path__ + "static/media/kurfess_franz.23482f69.jpeg";